import {Paging, Sorting} from '../helpers/constants';

import {equipmentActionTypes as types} from '../actions/actionTypes';

const initialState = {
  filters: {},
  pageInfo: {
    pageNumber: 1,
    pageSize: Paging.initialPageSize,
    pageSizes: Paging.pageSizes,
  },
  quickFilter: null,
  searchString: null,
  sortInfo: {
    sortColumn: 'name',
    sortOrder: Sorting.asc,
  },
  tags: {
    models: [],
    zips: [],
  },
  totalRows: 0,
};

export default function equipment(state = initialState, action) {
  switch (action.type) {
    case types.INITIAL_LOAD:
      return {
        ...state,
        totalRows: action.payload,
      };

    case types.PAGE_CHANGED:
      return {
        ...state,
        pageInfo: {
          ...state.pageInfo,
          pageNumber: action.payload.pageNumber,
          pageSize: action.payload.pageSize,
        },
      };

    case types.SORT_CHANGED:
      return {
        ...state,
        sortInfo: {
          sortColumn: action.payload.sortColumn,
          sortOrder: action.payload.sortOrder,
        },
      };

    case types.FILTER_OPTION_CHANGED:
      return {
        ...state,
        filterOption: action.payload,
      };

    case types.CHANGE_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    case types.ADD_TAG:
      const {models, zips} = state.tags;
      const current = action.payload.filter === 'models' ? models : zips;

      return {
        ...state,
        tags: {
          ...state.tags,
          [action.payload.filter]: [action.payload.tag, ...current],
        },
      };

    case types.CHANGE_QUICK_FILTER:
      return {
        ...state,
        quickFilter: action.payload,
      };

    case types.SEARCH:
      return {
        ...state,
        searchString: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/equipmentReducer.js